const PhoneIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M511.1 387.6c0 27.6-21.5 50.4-48.9 51.9-23.2 1.3-45.8 1.5-68.5 1.5-23.4 0-46.8-.2-70.2-1.5-27.4-1.5-48.9-24.3-48.9-51.9v-84.2c0-27.6 21.5-50.4 48.9-51.9 23.2-1.3 45.8-1.5 68.5-1.5 23.4 0 46.8.2 70.2 1.5 27.4 1.5 48.9 24.3 48.9 51.9v84.2zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0z" />
  </svg>
);

export default PhoneIcon;
